<template>
  <Head title="Dashboard" />
  <div id="accordion">
    <div class="card card-success">
      <div class="card-header">
        <h4 class="card-title w-100">
          <a class="d-block w-100" data-toggle="collapse" href="#collapseOne">
            REKAP KUNJUNGAN
          </a>
        </h4>
      </div>
      <div id="collapseOne" class="collapse" data-parent="#accordion">
        <div class="card-body table-responsive">
          <table class="table table-hover table-sm">
            <thead class="bg-info">
              <tr>
                <th>Tagihan</th>
                <th>Bawah</th>
                <th>Atas</th>
                <th>Macet</th>
                <th>CHR</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rekap in rekaps">
                <th>{{ rekap.team }}</th>
                <th>{{ rekap.tagihan_bawah }} | {{ rekap.kunjungan_bawah }} | {{ rekap.persen_bawah }}</th>
                <th>{{ rekap.tagihan_atas }} | {{ rekap.kunjungan_atas }} | {{ rekap.persen_atas }}</th>
                <th>{{ rekap.tagihan_macet }} | {{ rekap.kunjungan_macet }} | {{ rekap.persen_macet }}</th>
                <th>{{ rekap.tagihan_chr }} | {{ rekap.kunjungan_chr }} | {{ rekap.persen_chr }}</th>
                <th>{{ rekap.total_tagihan }} | {{ rekap.total_kunjungan }} | {{ rekap.persen_total }}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card card-primary">
      <div class="card-header">
        <h4 class="card-title w-100">
          <a class="d-block w-100" data-toggle="collapse" href="#collapseTwo">
            JANJI KUNJUNGAN
          </a>
        </h4>
      </div>
      <div id="collapseTwo" class="collapse show" data-parent="#accordion">
        <div class="card-body table-responsive">
          <data-table :columns="columns" :ajax="{ url: '/datatables/janji' }" 
            :columnDefs="[{ targets: [1], className: 'dt-body-center' }]" :order="[2, 'asc']"></data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import DataTable from '@/Forms/DataTable'

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    DataTable,
  },
  props: {
    rekaps: Object,
  },
  data() {
    return {
      columns: [
        { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
        { title: 'Kantor', data: 'tagihan.kantor' },
        { title: 'Tgl Janji', data: 'tgl_janji' },
        { title: 'Rekening', data: 'rek' },
        { title: 'Nama', data: 'tagihan.nama' },
        { title: 'Alamat', data: 'tagihan.alamat' },
        { title: 'Tgl Kunjungan', data: 'created_at' },
        { title: 'Penagihan', data: 'user.name' },
      ],
    }
  },
}
</script>
